import React from 'react';
import { FileTextIcon, DumbbellIcon, TargetIcon, UsersIcon, CheckIcon } from 'lucide-react';
const tags = ['Anfänger', 'Fortgeschrittene', 'Vereinsspieler', 'Schulmannschaft', 'Alle Altersgruppen'];
const stats = [{
  icon: FileTextIcon,
  value: '300+',
  label: 'Seiten'
}, {
  icon: DumbbellIcon,
  value: '200+',
  label: 'Einheiten'
}, {
  icon: TargetIcon,
  value: '120+',
  label: 'Drills & Spiele'
}, {
  icon: UsersIcon,
  value: 'Alle',
  label: 'Klassenstufen'
}];
export function SolutionSection() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-217">
          <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white font-bold text-[11px] sm:text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-218">
            🏆 Das vollständigste System für Basketball in Deutschland
          </div>

          <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] mb-4 tracking-tight" data-id="element-219">
            BASKETBALL <span className="text-[#FF6B00]" data-id="element-220">BEREIT 360™</span>
          </h2>

          <div className="inline-flex items-center gap-2 mb-6" data-id="element-221">
            <span className="h-px w-8 bg-[#FF6B00]" data-id="element-222" />
            <p className="text-[#FF6B00] text-base sm:text-lg font-black uppercase tracking-widest" data-id="element-223">
              6 Bände + 5 Boni
            </p>
            <span className="h-px w-8 bg-[#FF6B00]" data-id="element-224" />
          </div>

          <p className="text-[#5A5A66] text-base sm:text-lg mx-auto font-medium leading-relaxed" data-id="element-225">
            Über 300 Seiten mit fertigen Stundenentwürfen, Profi-Drills, Spielen
            und Management-Tools —{' '}
            <strong className="text-[#0A0A0A]" data-id="element-226">
              alles für Sie vorbereitet.
            </strong>
          </p>
        </div>

        {/* Stat cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12" data-id="element-227">
          {stats.map(({
          icon: Icon,
          value,
          label
        }) => <div key={label} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 text-center shadow-sm flex flex-col items-center" data-id="element-228">
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#FF6B00]/10 mb-4" data-id="element-229">
                <Icon className="w-6 h-6 text-[#FF6B00]" strokeWidth={2.5} data-id="element-230" />
              </span>
              <div className="text-3xl sm:text-4xl font-black text-[#0A0A0A] tracking-tight leading-none mb-1" data-id="element-231">
                {value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-232">
                {label}
              </div>
            </div>)}
        </div>

        {/* Coverage tags */}
        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-233">
          <p className="text-center text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-234">
            Volle Abdeckung, jede Kategorie
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-235">
            {tags.map(tag => <span key={tag} className="inline-flex items-center gap-1.5 bg-white border border-[#E5E5EA] text-[#0A0A0A] text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-236">
                <CheckIcon className="w-3.5 h-3.5 text-[#00C853]" strokeWidth={3} data-id="element-237" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}